import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchInternship } from '#/modules/orgDashboard/api/listing/orgDashboardApiFetchInternship';
import { orgDashboardRepostInternshipRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardRepostInternshipPageLoadable } from './OrgDashboardRepostInternshipPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, internshipId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardRepostInternshipRoute>) {
  const [internship] = await Promise.all([
    orgDashboardApiIsomorphicFetchInternship({ request, context })(
      orgId,
      internshipId,
    ),
    OrgDashboardRepostInternshipPageLoadable.load(),
  ]);

  return { internship };
}

export default function OrgDashboardRepostInternshipHorizonRoute({
  loaderData: { internship },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Repost an Internship Listing')}>
      <OrgDashboardRepostInternshipPageLoadable internship={internship} />
    </RouteModule>
  );
}
